import { Order } from 'storeTypes'

export const isAnyDelivered = (orders: Order[] = []) =>
    orders?.length > 1 &&
    orders?.some((order) => order.delivered && order.season_active)
